import React from "react";
import { ButtonComp, FormikTextAreaComp } from "../../../../../../components";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { AiOutlineClose } from "react-icons/ai";

const DeclineWithdrawalModal = ({ requestId, onDecline, onClose, isLoading }) => {
  const handleSubmit = async (values, { resetForm }) => {
    await onDecline(requestId, values.decline_reason);
    resetForm();
  };

  return (
    <div className="relative p-4">
      <Formik
        initialValues={{ decline_reason: "" }}
        validationSchema={Yup.object({
          decline_reason: Yup.string().required("Reason is required"),
        })}
        onSubmit={handleSubmit}
      >
        <Form className="">
          <AiOutlineClose
            onClick={onClose}
            className="absolute top-10 left-5"
            style={{ cursor: "pointer", fontSize: "20px", color: "var(--color-primary)" }}
          />
          <h4 className="border-b fw-bold py-2 mb-4 text-[1.5rem] !text-primary text-center w-full">
            Decline Withdrawal Request
          </h4>
          <FormikTextAreaComp
            rows={7}
            fieldName={"decline_reason"}
            labelClassName={"fw-2"}
            LabelText={"Reason for declining withdrawal"}
            placeholder={"Input reason for declining the withdrawal request"}
          />
          <div className="row justify-content-around pt-8">
            <div className="col-5">
              <ButtonComp
                btnText={"Cancel"}
                btnClassName={"text-1 btn w-100 py-2"}
                BorderColor={"var(--color-primary)"}
                onClick={onClose}
              />
            </div>
            <div className="col-5">
              <ButtonComp
                loading={isLoading}
                type="submit"
                btnText={"Decline"}
                ButtonInlineStyle={{ backgroundColor: "#FF4343" }}
                btnClassName={"border-0 text-white w-100 py-2 rounded"}
              />
            </div>
          </div>
        </Form>
      </Formik>
    </div>
  );
};

export default DeclineWithdrawalModal;

